import 'mdn-polyfills/Element.prototype.closest';

export default {
    methods: {
        scrollToError() {
            const elements = document.getElementsByClassName("invalid-feedback");
            if (elements.length > 0) {
                const element = elements[0].closest("fieldset") || elements[0].closest("form")
                    || elements[0].closest("div");
                if (element !== null) {
                    element.scrollIntoView({behavior: 'smooth'});
                }
            }
        }
    },
};